export default __webpack_public_path__ + "static/media/makemerry.0879db3e.png";